import { actionCreator } from "../common/common.reducer";
import { isLandlordTypeGuard } from "../common/models/userInfo";
import { IApplicationState } from "../redux/root-reducer";
import { generateMeterItems } from "../meter/meter.actions";
import {
  deletePhoneNumberUrl,
  meterEventsSubscriptionsUrl,
} from "../common/infrastructure/endpoints";
import { del, put } from "../common/infrastructure/requests";
import { IMeterEventSubscriptionObject } from "./types";
import { actionCreator as meterActionCreator } from "../meter/meter.reducer";
import { actionCreator as sensorsActionCreator } from "../safetySensors/Sensors.reducer";
import { generateSensorItems } from "safetySensors/Sensors.actions";

export const addPhoneNumberAction =
  (phonenumber: string) => async (dispatch: ({}) => void) => {
    dispatch(actionCreator.setPhoneNumber(phonenumber));
  };

export const removePhoneNumberAction =
  (phonenumber: string) =>
  async (dispatch: ({}) => void, getState: () => IApplicationState) => {
    const state = getState();
    if (shouldToggleMeters(state, phonenumber)) {
      const selectedDomain =
        state.common.selectedDomain?.Code ??
        state.common.currentUserInfo.Domains[0].Code;

      const meterEventSubs = [
        ...generateMeterItems(state.meters.meters, false),
        ...generateSensorItems(state.sensors.allSensorDataForSingleNode, false),
      ];

      const resp = await put<any, IMeterEventSubscriptionObject[]>(
        meterEventsSubscriptionsUrl(selectedDomain),
        meterEventSubs
      );
      if (!resp) {
        dispatch(meterActionCreator.fetchingDataError);
        return;
      }
      dispatch(meterActionCreator.toggleMonitoringForAllMeters(false));
      dispatch(sensorsActionCreator.toggleMonitoringForAllSensors(false));
    }

    const success = await deletePhoneNumber(phonenumber);
    success && dispatch(actionCreator.removePhoneNumber(phonenumber));
  };

export const deletePhoneNumber = async (phoneNumber: string) => {
  try {
    const resp = await del<any>(deletePhoneNumberUrl(phoneNumber));
    if (resp) return true;

    return false;
  } catch (e) {
    return false;
  }
};
const shouldToggleMeters = (
  state: IApplicationState,
  phoneNumberToDelete: string
) => {
  if (!isLandlordTypeGuard(state.common.currentUserInfo)) {
    const phoneNumbersAfterDelete =
      state.common.currentUserInfo.PhoneNumbers.filter(
        (p) => p !== phoneNumberToDelete
      );
    if (phoneNumbersAfterDelete.length < 1) {
      return true;
    }
    return false;
  }
  return false;
};
